import muster from '@dbk-legacy/muster';
import addCommonAssets from './assets-common';

export default () => addCommonAssets(muster());
